import Box from "@mui/material/Box"
import Paper from "@mui/material/Paper"
import Tab from "@mui/material/Tab"
import Tabs from "@mui/material/Tabs"
import { Link, Outlet, useLocation } from "@tanstack/react-router"
import type { FC } from "react"

import { PageHeader } from "@/components/PageHeader/PageHeader"

export const InventoryLayout: FC = () => {
  const location = useLocation()

  const tabs = [
    {
      label: "Product Inventory",
      path: "/app/inventory/products",
    },
    {
      label: "Adjustment History",
      path: "/app/inventory/adjustment-history",
    },
    {
      label: "Transfers",
      path: "/app/inventory/transfers",
    },
  ]

  const activeTab = tabs.find((tab) => location.pathname.startsWith(tab.path)) ?? tabs[0]

  return (
    <Paper
      elevation={0}
      className='flex min-h-0 grow flex-col overflow-hidden rounded-lg bg-white'
      data-testid='inventory'
    >
      <PageHeader title='Inventory Management' />
      <Box className='flex w-full flex-1 flex-col overflow-hidden'>
        <Tabs value={activeTab.path} variant='scrollable' scrollButtons='auto'>
          {tabs.map((tab) => (
            <Tab key={tab.path} label={tab.label} value={tab.path} component={Link} to={tab.path} />
          ))}
        </Tabs>
        <Box className='flex min-h-0 grow flex-col px-1 pb-1 pt-6'>
          <Outlet />
        </Box>
      </Box>
    </Paper>
  )
}
